module.exports = __webpack_public_path__ + "static/media/29ADMSPC19.a5a822dc.jpg";